import type { Locale } from '@whizz/api-model';
import { TRAINING_MODULES } from '../../../util/vars';

export type WelcomeLocaleFlags = {
  hasTraining: boolean;
  isThai: boolean;
  textAlign: string;
};

export const getWelcomeLocaleFlags = (locale: Locale | null): WelcomeLocaleFlags => {
  const hasTraining = !!TRAINING_MODULES[locale?.id as string];
  const isThai = 'th-th' === locale?.id;
  const textAlign = isThai ? 'text-left' : 'text-left md:text-justify';

  return { hasTraining, isThai, textAlign };
};
